import { useEffect } from 'react';
import { ActionButton } from '../../../components/vertical-dot/popper';
import { type AccessProfileScope } from './types';

export const AccessProfileTableHeader = ({
  scope,
  actions,
  tableActions,
  hasMousePosition,
  resetMousePosition,
}: {
  scope: AccessProfileScope;
  actions: any;
  tableActions: any;
  hasMousePosition?: boolean;
  resetMousePosition?: () => void;
}): any[] => {
  if (scope === 'Role' && resetMousePosition) {
    useEffect(() => {
      function handleClickOutside(event: any): void {
        if (!(event.target as HTMLElement).className.includes('roles-popovers')) {
          resetMousePosition();
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [resetMousePosition]);
  }

  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        return (
          <td>
            <ActionButton
              actions={tableActions}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
};
